import { useEffect, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider"
import * as yup from 'yup';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Grid, IconButton, TextField, ThemeProvider, Tooltip } from "@mui/material";
import customtheme from '../../../themes';
import { useSelector } from "react-redux";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import packageApi from "../../../api/packageApi";
import helper from "../../../helper";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import CustomDateInput from "../../../Components/CustomDateInput";
import moment from "jalali-moment";
import { TbEdit } from "react-icons/tb";
import { ImCheckmark } from "react-icons/im";
import EnumMapper from "../../../EnumMapper";

const AddPackageEvent = ({ Event, AddPackageEvent }) => {

    const [isloading, setIsloading] = useState(false);
    const [city, setCity] = useState([]);
    const [eventType, setEventType] = useState([]);
    const [showError, setShowError] = useState(false);
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),


    });
    useEffect(() => {

        getcityDropDown();
        getEventTypeDropDown();

    }, []);


    const getcityDropDown = () => {
        packageApi.GetArabiaCityDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setCity(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((err) => {
                console.log(err);
            });
    }

    const getEventTypeDropDown = () => {

        packageApi.GetEventTypeDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setEventType(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((err) => {
                console.log(err);
            });
    }
    const resetForm = () => {
        setShowError(false);

        setValue('startT', null);
        setValue('endT', null);
        setValue('eventTitle', null);
        setValue('eventTypeId', null);
        setValue('fromCity', null);
        setValue('toCity', null);

    }
    const onSubmit = () => {

    }
    const AddEvent = () => {
        setShowError(false);
        let startT = null;
        if (watch("startT"))
            startT = watch("startT");

        let endT = null;
        if (watch("endT"))
            endT = watch("endT");

        let Eventdescr = null;
        if (watch("eventTitle"))
            Eventdescr = watch("eventTitle");
        let eventTypeId = null;
        let eventTypeText = null;
        if (watch("eventTypeId")) {
            eventTypeId = parseInt(watch("eventTypeId"));
            eventTypeText = (eventType.find(t => parseInt(t.id) === eventTypeId))?.label;
        }

        let fromCity = null;
        let fromCityText = null;
        if (watch("fromCity")) {
            fromCity = parseInt(watch("fromCity"));
            fromCityText = (city.find(t => parseInt(t.id) === fromCity))?.label;
        }

        let toCity = null;
        let toCityText = null;
        if (watch("toCity")) {
            toCity = parseInt(watch("toCity"));
            toCityText = (city.find(t => parseInt(t.id) === toCity))?.label;
        }
        if (!(helper.checkRequiredInputSurvey(eventTypeId, Eventdescr, startT, fromCity, endT, toCity))) {
            setShowError(true);
        }
        else {
            const eventdata = {
                "description": Eventdescr,
                "eventTypeId": eventTypeId,
                "eventTypeText": eventTypeText,
                "fromCity": fromCity,
                "fromCityText": fromCityText,
                "toCity": toCity,
                "toCityText": toCityText,
                "startT": startT,
                "endT": endT,
            }
            AddPackageEvent(eventdata);

        }

    }

    return (
        <ThemeProvider theme={customtheme(customization)}>
            <RtlProvider>
                <Box sstyle={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item md={2} xs={12} >
                                <RHFAutocomplete
                                    control={control}
                                    options={eventType}
                                    name="eventTypeId"
                                    placeholder="نوع رویداد"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                            </Grid>
                            {(watch("eventTypeId")) && <>
                                <Grid item md={3} xs={12} >
                                    <TextField label="شرح رویداد سفر"  {...register("eventTitle")} fullWidth ></TextField>
                                </Grid>

                                {String(watch("eventTypeId")) !== String(EnumMapper.PackageDetailsEventType.ReservePlanRequest) &&
                                    <Grid item md={1.5} xs={5.5} >
                                        <Controller
                                            control={control}
                                            name="startT"
                                            rules={{ required: true }}
                                            render={({ field: { onChange, value } }) => {
                                                const pickerValue =
                                                    value && typeof value === "string"
                                                        ? moment(value, "HH:mm").toDate()
                                                        : value;

                                                return (
                                                    <DatePicker
                                                        disableDayPicker
                                                        format="HH:mm"
                                                        value={pickerValue}
                                                        onChange={(date) => {
                                                            if (date?.isValid) {
                                                                const formatted = moment(date.toDate()).format("HH:mm");
                                                                onChange(formatted);
                                                            } else {
                                                                onChange("");
                                                            }
                                                        }}
                                                        plugins={[<TimePicker hideSeconds />]}
                                                        render={<CustomDateInput label={"از ساعت"} />}
                                                    />
                                                );
                                            }}
                                        />

                                    </Grid>}
                                <Grid item md={1.5} xs={5.5}>
                                    <RHFAutocomplete
                                        control={control}
                                        options={city}
                                        name="fromCity"
                                        placeholder="از شهر"
                                        style={{
                                            border: "none",
                                            padding: 0
                                        }}
                                    />
                                </Grid>
                                {(String(watch("eventTypeId")) !== String(EnumMapper.PackageDetailsEventType.InnerCity)) &&
                                 (String(watch("eventTypeId")) !== String(EnumMapper.PackageDetailsEventType.AtTheDisposalOfTheGroup)) && 
                                 (String(watch("eventTypeId")) !== String(EnumMapper.PackageDetailsEventType.AtYourDisposal)) && 
                                 <>
                                    {String(watch("eventTypeId")) !== String(EnumMapper.PackageDetailsEventType.ReservePlanRequest) &&
                                        <Grid item md={1.5} xs={5.5} >
                                            <Controller
                                                control={control}
                                                name="endT"
                                                rules={{ required: true }}
                                                render={({ field: { onChange, value } }) => {
                                                    const pickerValue =
                                                        value && typeof value === "string"
                                                            ? moment(value, "HH:mm").toDate()
                                                            : value;

                                                    return (
                                                        <DatePicker
                                                            disableDayPicker
                                                            format="HH:mm"
                                                            value={pickerValue}
                                                            onChange={(date) => {
                                                                if (date?.isValid) {
                                                                    const formatted = moment(date.toDate()).format("HH:mm");
                                                                    onChange(formatted);
                                                                } else {
                                                                    onChange("");
                                                                }
                                                            }}
                                                            plugins={[<TimePicker hideSeconds />]}
                                                            render={<CustomDateInput label={"تا ساعت"} />}
                                                        />
                                                    );
                                                }}
                                            />

                                        </Grid>}
                                    <Grid item md={1.5} xs={5.5}>
                                        <RHFAutocomplete
                                            control={control}
                                            options={city}
                                            name="toCity"
                                            placeholder="به شهر"
                                            style={{
                                                border: "none",
                                                padding: 0
                                            }}
                                        />
                                    </Grid>
                                </>}
                                <Grid item md={2} xs={4}>
                                    <Button
                                        disabled={isloading}
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            fontSize: "16px",
                                            width: "7rem",
                                            height: "3rem",
                                        }}
                                        
                                        onClick={() => { AddEvent() }}
                                    >
                                        <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                        افزودن
                                        <ImCheckmark size={24} />
                                    </Button>

                                </Grid>

                            </>}

                        </Grid>
                        {(showError) && <p className="error">{' موارد خواسته شده را تکمیل کنید'}</p>}

                    </form>
                </Box>
            </RtlProvider>
        </ThemeProvider>
    );

}
export default AddPackageEvent;